<template>
  <div class="footer-menu">
    <div class="menu">
      <span>About</span>
      <span>Contact</span>
      <span>Policies</span>
    </div>
    <div class="setting-button"></div>
  </div>
</template>

<script>
export default {
  name: 'footer-menu'
}
</script>

<style lang="scss" scoped>
.footer-menu {
  position: relative;
  margin: auto;
  left: 0;
  right: 0;
  max-width: 1080px;
  height: 150px;
  border-top: 1px solid #dddddd;
  .logo {
    font-size: 14px;
    font-weight: 600;
    margin: 30px 0 0 0;
    width: 136px;
    height: 26px;
    position: absolute;
  }

  .menu {
    margin: 30px 0 0 0;
    position: absolute;
    span {
      font-family: Poppins;
      font-size: 16px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1px;
      color: #000000;
      margin: 0 20px 0 0;
    }
  }
}
</style>
